import React from 'react';
import {Helmet} from "react-helmet";
import Spinner from '../../audi-ui-components/Spinner';
import Layout from '../../components/Layout';
import Location from './components/Location';
import Frame from './components/Frame';
import SearchForm from './components/SearchForm';
import List from './components/List';
import API from '../../functions/api';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import queryString from 'query-string';
import {
    UI_AUDI,
    DEFAULT_THEME,
} from '../../constants';
import "./locate.scss";

const gqlFields = `id
type
name
address postcode state suburb
email phone website
latitude longitude mapsURL
rating
totalReviews
message
monday tuesday wednesday thursday friday saturday sunday
webKey
dealer {
  dealerCode dealerId name email phone website isAudiSportDealer licenceNo
}`;

const locationTypes = ["Sales", "Service", "TradePartCentre", "RepairCentre"];

class LocateADealer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lockdownDealers: null,
            lockdownFilter: null,
            allLocations: null,
            filteredLocations: null,
            selectedLocation: null,
            searchError: null,
        }
    }

    componentDidMount() {
        gtmPageview(this.props.location.pathname);
        const query = queryString.parse(this.props.location.search);
        var qIds = query.d ? query.d.split(",") : false;
        var dealerCodes = []; var dealerIds = [];
        if (qIds && qIds.length > 0) {
          qIds.forEach((id, idx) => {
            if (/^a[0-9]+$/.test(id.toLowerCase())) {
              dealerCodes.push(id);
            }
            if (/^[0-9]+$/.test(id)) {
              dealerIds.push(parseInt(id));
            }
          });
        }
        if (dealerCodes.length > 0 || dealerIds.length > 0) {
            // map is locked to specified dealers
            this.getDataLoop(
              [],
              "locationList",
              {
                filter: {
                  or: [
                    {and: [{type: {in: locationTypes}}, {status: {eq: true}}, {dealerCode: {in: dealerCodes}}]},
                    {and: [{type: {in: locationTypes}}, {status: {eq: true}}, {dealer: {dealerId: {in: dealerIds}}}]}
                  ]
                },
                sort: {name: "ASC"}
              },
              (list) => {
                if (list?.length > 0) {
                  this.setState({lockdownDealers: qIds, filteredLocations: list, loading: false});
                } else {
                  this.getAllDealers(query);
                }
              },
              (err) => {
                this.setState({loading: false, searchError: "An error has occured"});
              }
            );
        } else {
            // fetch all
            this.getAllDealers(query);
        }
    }
    
    getDataLoop = (list = [], gqlQueryName = "locationList", gqlVars = {}, cb = ()=>{}, errCb = ()=>{}) => {
      // console.log("getDataLoop", list.length);
      let gqlQuery = /* GraphQL */`query ($skip: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput) {
        locationList(skip: $skip, take: 50, order: [$sort], where: $filter) {
          items {
            ${gqlFields}
          }
          totalCount
        }
      }`;
      if (gqlQueryName === "locationsBySuburb") {
        gqlQuery = /* GraphQL */`query ($skip: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput, $suburbId: Int!) {
          locationsBySuburb(skip: $skip, take: 50, order: [$sort], where: $filter, suburbId: $suburbId) {
            items {
              ${gqlFields}
            }
            totalCount
          }
        }`;
      }
      if (gqlQueryName === "locationsByPostcode") {
         gqlQuery = /* GraphQL */`query ($skip: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput, $postcode: String) {
          locationsByPostcode(skip: $skip, take: 50, order: [$sort], where: $filter, postcode: $postcode) {
            items {
              ${gqlFields}
            }
            totalCount
          }
        }`;
      }
      gqlVars.skip = list.length;
      if(!gqlVars.sort) { gqlVars.sort = {}; }
      API.post(
        process.env.RAZZLE_GQLAPI,
        {
          query: gqlQuery,
          variables: gqlVars
        }
      ).then(response => {
          let items = response.data?.data[gqlQueryName]?.items;
          let newList = [...list, ...items];
          if (newList.length < response.data?.data[gqlQueryName]?.totalCount) {
            //load more
            this.getDataLoop(newList, gqlQueryName, gqlVars, cb, errCb);
          } else {
            cb(newList);
          }
      }).catch(err => {
          console.error(err);
          errCb(err);
      });
    }
    
    getAllDealers = (query) => {
      this.getDataLoop(
        [],
        "locationList",
        {
          filter: {type: {in: ["Sales", "Service", "TradePartCentre"]}, status: {eq: true}},
          sort: {name: "ASC"},
        },
        (list) => {
          if (query.f && query.dosearch) {
            // also fetch filtered
            let gqlFilter = {type: {in: ["Sales", "Service", "TradePartCentre"]}, status: {eq: true}};
            if (query.f === "sport") {
              gqlFilter.dealer = {isAudiSportDealer: {eq: true}};
            }
            this.getDataLoop(
              [],
              "locationList",
              {filter: gqlFilter, sort: {name: "ASC"}},
              (fList) => {
                this.setState({allLocations: list, filteredLocations: fList, loading: false});
              },
              (fErr) => {
                this.setState({allLocations: list, loading: false, searchError: "An error has occured"});
              }
            );
          } else {
            this.setState({allLocations: list, loading: false});
          }
        },
        (err) => {
          this.setState({loading: false, searchError: "An error has occured"});
        }
      );
    }

    trackEvent = (eventName, data) => {
        // thneed.trigger(eventName, 'locateADealer', data, true);
        gtmPush("locateADealer", eventName, "locateADealer", data);
    }

    handleSearchSubmit = (searchVals) => {
        this.trackEvent('searchSubmit', searchVals);
        this.setState({loading: true, searchError: null});

        var gqlFilter = {type: {in: locationTypes}, status: {eq: true}};
        if (searchVals.searchBy === "state") {
            gqlFilter.state = {eq: searchVals.state};
        }
        if (searchVals.searchFor === "Sales" || searchVals.searchFor === "Service" || searchVals.searchFor === "TradePartCentre" || searchVals.searchFor === "RepairCentre") {
            gqlFilter.type = {eq: searchVals.searchFor};
        }
        if (searchVals.searchBy === "suburb") {
            this.getDataLoop([], "locationsBySuburb", {filter: gqlFilter, suburbId: parseInt(searchVals.suburb)}, this.handleSearchResult, (err) => {
              // console.error(err);
              let msg = "An error has occured";
              if (err.status === 404) { msg = "We couldn't find any dealers matching your search"; }
              this.setState({loading: false, searchError: msg});
            });
        } else if (searchVals.searchBy === "postcode") {
          this.getDataLoop([], "locationsByPostcode", {filter: gqlFilter, postcode: `${searchVals.postcode}`}, this.handleSearchResult, (err) => {
            // console.error(err);
            let msg = "An error has occured";
            if (err.status === 404) { msg = "We couldn't find any dealers matching your search"; }
            this.setState({loading: false, searchError: msg});
          });
        } else {
            this.getDataLoop([], "locationList", {filter: gqlFilter}, this.handleSearchResult, (err) => {
              // console.error(err);
              let msg = "An error has occured";
              if (err.status === 404) { msg = "We couldn't find any dealers matching your search"; }
              this.setState({loading: false, searchError: msg});
            });
        }
    }
    
    handleSearchResult = (list) => {
        if (!list || list.length === 0 || !list[0].id) {
            this.setState({loading: false, searchError: "No dealers found"});
        } else if (list.length === 1) {
            this.setState({selectedLocation: list[0], filteredLocations: list, loading: false});
            this.trackEvent('selectDealer', {dealerId: list[0].dealer?.dealerId});
        } else {
            this.setState({filteredLocations: list, loading: false});
        }
    }

    getBackButtonText = () => {
        const { lockdownDealers, filteredLocations, selectedLocation } = this.state;
        if (!lockdownDealers || lockdownDealers.length === 0) {
            if (selectedLocation) {
                return 'Back to search';
            }
            return null;
        }
        if (lockdownDealers?.length > 0 && filteredLocations?.length > 1 && selectedLocation) {
            return 'Back to list';
        }
        return null;
    }

    handleBackClick = () => {
        // console.log("LocateADealer handleBackClick");
        this.trackEvent('backButtonClick', { page: this.state.selectedLocation ? 'dealer' : 'searchResults', });
        if (this.state.selectedLocation) {
            return this.setState({selectedLocation: null});
        }
        return this.setState({filteredLocations: null});
    }

    getMapLocations = () => {
        if (this.state.selectedLocation) {
            return [this.state.selectedLocation];
        } else if (this.state.filteredLocations) {
            return this.state.filteredLocations;
        }
        return this.state.allLocations;
    }

    handleSelectLocation = (loc) => {
        this.trackEvent('selectDealer', {dealerId: loc.dealer?.dealerId});
        this.setState({selectedLocation: loc});
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const locked = !!query.d && this.state.lockdownDealers?.length > 0;
        const { loading, selectedLocation } = this.state;
        
        return (
            <Layout ui={query.ui || UI_AUDI} embedded={query.embedded} wide theme={theme}>
                <Helmet>
                    <title>Find your local Audi dealership | Audi Australia</title>
                </Helmet>

                <main className="locate position-relative">
                    {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                    <Frame title="Find a dealer or service centre"
                        locations={this.getMapLocations()}
                        activeTab={this.state.activeTab}
                        onClick={this.handleSelectLocation}
                        backButtonText={this.getBackButtonText()}
                        onBackClick={this.handleBackClick}
                    >
                        {selectedLocation && <Location
                          key={selectedLocation.id}
                          trackEvent={(e) => { this.trackEvent(`dealer${e}`, {dealerName: selectedLocation.dealerName, location: selectedLocation.type}); }}
                          {...selectedLocation}
                          theme={theme}
                        />}
                        {!locked && <SearchForm
                            searchBy="suburb"
                            onSubmit={this.handleSearchSubmit}
                            searchFilters
                            filter={query.f}
                            error={this.state.searchError}
                            theme={theme}
                            className={selectedLocation ? "d-none" : ""}
                        />}
                        {this.state.filteredLocations && <List
                            locations={this.state.filteredLocations}
                            onClick={this.handleSelectLocation}
                            className={selectedLocation ? "d-none" : ""}
                        />}
                    </Frame>

                </main>
            </Layout>
        );
    }
}

export default LocateADealer;
